// services/support/userService.ts
import axios from "axios";
import { User } from "../types/features/User";
import { PaginatedResponse } from "../types/core/PaginatedResponse";
import { MAIN_API_URL } from "../config/api";

export const userService = {
  // Liste paginée des users
  async getUsers(token: string, izilifeToken: string, page: number = 1, perPage: number = 20): Promise<PaginatedResponse<User>> {
    const response = await axios.get<PaginatedResponse<User>>(`${MAIN_API_URL}/users`, {
      params: { page, per_page: perPage },
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-Izilife-Token': izilifeToken,  // Correction du nom de l'en-tête
        'Accept': 'application/json',
      },
    });

    console.log("users", response.data);
    return response.data;
  },

  async getUserById(token: string, izilifeToken: string, id: string): Promise<User | null> {
    const response = await axios.get<User>(`${MAIN_API_URL}/users/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-Izilife-Token': izilifeToken,
        'Accept': 'application/json',
      },
    });
    return response.data;
  },

  // Créer un utilisateur (admin seulement)
  async createUser(token: string, izilifeToken: string, data: any): Promise<User> {
    const response = await axios.post<User>(`${MAIN_API_URL}/users`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-Izilife-Token': izilifeToken,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  // Mettre à jour un utilisateur
  async updateUser(token: string, izilifeToken: string, id: string, data: Partial<User>): Promise<User> {
    const response = await axios.put<User>(`${MAIN_API_URL}/users/${id}`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-Izilife-Token': izilifeToken,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  // Supprimer un utilisateur (admin seulement)
  async deleteUser(token: string, izilifeToken: string, id: string): Promise<void> {
    await axios.delete(`${MAIN_API_URL}/users/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-Izilife-Token': izilifeToken,
        'Accept': 'application/json',
      },
    });
  },
};